import React from "react";
import { MultiSelect, Textfield } from "../../../../../../components/core";
import DateRangeTimePicker from "../../../../../../components/core/date-range-with-time-picker";
import PrimereactDateRange from "../../../../../../components/core/date-range-primereact";

const AddBehavioralMajorDetails = ({
  behavioralVars,
  handleChange,
  lockerName,
}) => {
  return (
    <div className="w-full py-2">
      {/* <div className="font-semibold">Promotion Details:</div> */}

      <div className="flex flex-col gap-3 px-[1.25rem]">
        <div className="grid grid-cols-12 w-full gap-3 items-center">
          <div className="col-span-6">
            <div className="grid grid-cols-12  items-center">
              <div className="col-span-4">
                <label>Campaign Name:</label>
              </div>
              <div className={"col-span-8"}>
                <Textfield
                  name={"campaignName"}
                  value={behavioralVars.campaignName}
                  onChange={(event) => handleChange(event)}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-12 w-full gap-3 items-center">
          <div className="col-span-6">
            <div className="grid grid-cols-12  items-center">
              <div className="col-span-4">
                <label>Campaign Date:</label>
              </div>
              <div className={"col-span-8"}>
                <PrimereactDateRange
                  startDateName="startDate"
                  endDateName="endDate"
                  startTimeName="startTime"
                  endTimeName="endTime"
                  timeOnly={true}
                  min={new Date("2021-01-01")}
                  max={new Date()}
                  readOnlyInput={true}
                  startDate={behavioralVars.startDate}
                  endDate={behavioralVars.endDate}
                  startTime={behavioralVars.startTime}
                  endTime={behavioralVars.endTime}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-12 w-full gap-3 items-center">
          <div className="col-span-6 ">
            {/* <div className="gap-2 items-center"> */}
            <div className="grid grid-cols-12  items-center">
              <label className="col-span-4">Locker Name:</label>

              <div className="col-span-8">
                <MultiSelect
                  items={lockerName}
                  name={"lockerId"}
                  value={behavioralVars.lockerId}
                  // onChange={(e) => {
                  // 	handleChange();
                  // 	setSelectedLockerName(e.target.value);
                  // }}
                  onChange={handleChange}
                />
              </div>
            </div>
            {/* </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddBehavioralMajorDetails;
